export const UPDATE_WELCOME_VIDEO = 'welcome_video/UPDATE_WELCOME_VIDEO';